import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tax-included",
  "use": "icon-tax-included-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"icon-tax-included\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.5 14a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm0 1a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z\" fill=\"#4071FF\" /><rect x=\"7\" y=\"6\" width=\"1\" height=\"6\" rx=\".5\" fill=\"#4071FF\" /><circle cx=\"7.5\" cy=\"4.5\" r=\".5\" fill=\"#4071FF\" /><rect x=\"6\" y=\"6\" width=\"2\" height=\"1\" rx=\".5\" fill=\"#4071FF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol